import React from 'react';

const Navbar = () => (
  <header style={{ padding: '30px', textAlign: 'center', borderBottom: '1px solid #eee' }}>
    <div style={{ fontSize: '40px', marginBottom: '10px' }}>🎓 📖</div>
    <h1 style={{ margin: '0', fontSize: '28px', color: '#2c3e50' }}>LLAP</h1>
    <h2 style={{ margin: '5px 0', fontSize: '20px', color: '#34495e' }}>MRS. SHAHD ABULILA</h2>
    <p style={{ margin: '0', fontSize: '16px', color: '#7f8c8d' }}>Language Learning Academy</p>
    <p style={{ fontStyle: 'italic', margin: '10px 0', fontSize: '14px' }}>Learn • Communicate • Succeed</p>
  </header>
);

export default Navbar;